export const ResetPasswordMessage = ({
    // We need to pull these values from LDD Account Settings
    PasswordLength = 0,
    PasswordComplexity = false,
}: {
    PasswordLength?: number;
    PasswordComplexity?: boolean;
}) => {
    return (
        <div className="alert alert-info">
            {(PasswordLength > 0 || PasswordComplexity) && (
                <>
                    Password must
                    {PasswordLength > 0 && (
                        <span> be at least <b>{PasswordLength} characters long</b></span>
                    )}
                    {PasswordLength > 0 && PasswordComplexity && " and"}
                    {PasswordComplexity && (
                        <span> contain at least <b>1 letter and 1 number</b></span>
                    )}
                    .
                    <br />
                </>
            )}
            <span>Special characters are limited to <b>!@#$^&*-_</b>.</span>
        </div>
    );
};

export default ResetPasswordMessage;